function edit({
  id,
  changes
}) {
  return function (state) {
    return {
      ...state,
      scope: {
        ...state.scope,
        index: {
          ...state.scope.index,
          [id]: {
            ...state.scope.index[id],
            ...changes,
            id
          }
        }
      }
    };
  };
}
export const mutations = {
  add: ({
    scope
  }) => state => {
    return {
      ...state,
      index: {
        ...state.index,
        [scope.id]: scope
      }
    };
  },
  delete: ({
    scopeId
  }) => state => {
    const id = scopeId;
    const truncated = {
      ...state.index
    };
    delete truncated[id];
    return {
      ...state,
      index: {
        ...truncated
      }
    };
  },
  edit
};
export const initialState = () => ({
  index: {},
  relates_to: [],
  applicability: [],
  service_types: []
});